/* this file is transformed by vux-loader */
/* eslint-disable */
/* this file is transformed by vux-loader */

/* eslint-disable */

/*
 * @Description:
 * @Date: 2018-12-21 17:02:06
 */
import Vue from 'vue';
import router from './index';
import store from '../store/index';
import querystring from "vux/src/tools/querystring/index.js";
import wxShareInfo from '@/public/wxShare'; //初始化wx 每次转跳必须初始化一次

import { userGuide } from '@/public/userGuide.js';
import { getUsersData, klnPublicJump, clearExpireSession, reportLogin, tmpSetUserSession } from '@/api/ajax';
import api from '@/api/index';
import config from '@/config/index.js';
var Api = new api();
export default (function () {
  /*
   * storage 注意事项  ${store} url回跳地址 from 来源类型
   *                 ${vueRouterBackPage} 页面内的重定向
   * */
  //用于微信授权后重定向  IOS 不识别#后面 目前暂定这种方法
  var watchStorageHasToGoPage = function watchStorageHasToGoPage() {
    var urls = location.href; //todo 临时使用

    if (/courseDetail|liveDetail/.test(urls)) {
      if (!/\?/.test(urls.split('courseDetail/')[1]) && /&/.test(urls.split('courseDetail/')[1]) || !/\?/.test(urls.split('liveDetail/')[1]) && /&/.test(urls.split('liveDetail/')[1])) {
        location.href = urls.replace(/&/, '?');
      }
    } // 回跳授权前的地址   解决页面卡死问题
    // // TODO:  已解决 可以废弃
    // function goBackFunc(){
    //   let page2 = localStorage.vueRouterBackPage
    //   localStorage.removeItem('vueRouterBackPage')
    //   location.href = page2
    // }
    // if (localStorage.vueRouterBackPage) {
    //     if(/home/.test(urls)){
    //       localStorage.removeItem('vueRouterBackPage')
    //     }else{
    //       if(/headlineDetail|liveDetail|courseDetail/.test(urls)){
    //         //如果是从分享进入的
    //         if(/shareFlag=true/.test(urls)){
    //           localStorage.removeItem('vueRouterBackPage')
    //         }else{
    //           // goBackFunc()
    //         }
    //       }else{
    //         // goBackFunc()
    //       }
    //     }
    //     return false
    // }else{
    //   return true
    // }

  };

  watchStorageHasToGoPage(); // 格式化从微信分享过来的URL 防止URL未注册现象
  // let wxUrlFormat = () => {
  //     if(/\.html\?from\=/.test(location.href)) {
  //         let urls = location.href
  //         let infoUrl = urls.split('?')[1].split("#")[0]
  //         let formatReg = new RegExp(infoUrl)
  //         urls = urls.replace(formatReg, '').replace(/\?/, '')
  //         location.href = urls
  //         return false
  //     } else {
  //
  //     }
  // }
  //
  // wxUrlFormat()

  /*
   * 每次进入页面 重新健全一次 并且 保存用户信息
   * */
  //kln

  if (Api.isKln()) {
    localStorage.clear();

    var userInfo = _querystring.parse(navigator.userAgent.split('?')[1]);

    var sendData = {
      sign: userInfo.accessToken,
      phone: userInfo.userPhone,
      userId: 0
    };
    klnPublicJump(sendData).then(function (res) {
      if (res.data.status == 1) {
        Api.setVuexStorage(res.data.users);
      } else {
        Vue.$vux.toast.show({
          text: res.data.message,
          position: 'top',
          type: 'text',
          width: '5rem'
        });
      }
    }).catch(function (e) {
      Vue.$vux.toast.show({
        text: e,
        position: 'top',
        type: 'text',
        width: '5rem'
      });
    });
  } //wx
  else {
    var fkUserInfo = Api.getStorage('wxUserInfo') || null; // //去除测试数据缓存 2017-12-25 设置

    if (fkUserInfo && fkUserInfo.id == '514033' && fkUserInfo.phone == '13283379288') {
      sessionStorage.clear(); //   clearExpireSession().then(res => {

      location.reload(); //   })

      return false;
    } // else {
    //   if (firstEntery && firstEntery.phone) {
    //     getUsersData({ userId: firstEntery.id }).then(res => {
    //       if (!res.data.users || !res.data.users.wxOpenId) {
    //
    //         localStorage.clear()
    //         // location.reload()
    //         return false
    //       } else {
    //         Api.setVuexStorage(res.data.users)
    //
    //         // 初始化神测
    //         let storageObj = Api.getStorage('wxUserInfo');
    //         if (Vue.prototype.$sa.store.getDistinctId() != storageObj.id) {
    //           Vue.prototype.$sa.login(storageObj)
    //         }
    //
    //       }
    //     }).catch(res => {
    //
    //     })
    //   }
    // }

  }

  router.beforeEach(function (to, from, next) {
    // TODO: 运营测试事故， 故临时使用
    // if(to.name == 'liveDetail' && to.params.id == 8225) {
    //   location.href = 'http://cdn.yxvzb.com/WEB/static-html/sorry.html'
    //   return false
    // }
    document.title = to.meta.title;

    try {
      if (to.name == 'zoneList') {
        Api.showNativeBack('false');
      } else {
        Api.showNativeBack('true');
      }
    } catch (e) {} //与APP交互
    //todo 此处必须优化 android 交互每次执行后返回error


    try {
      Api.nativeEvent(to.meta.title);
    } catch (e) {// alert('没找到doSome')
    } // 切换loading


    store.dispatch('change', true); //改变headerTitle

    store.dispatch('headerName', to.meta.title); //如果不存在的路径则重定向首页

    if (to.matched.length === 0) {
      next({
        name: 'home'
      });
    }

    var _to$query = to.query,
        platform = _to$query.platform,
        userId = _to$query.userId;

    if (['android', 'ios'].includes(platform) && userId || platform === 'admin') {
      next();
      return;
    } //用户转跳规则


    userGuide(store, to, next); //通用分享

    if (!/courseDetail|liveDetail|headlineDetail|specialTopic/.test(to.path)) {
      wxShareInfo('医学V视界', '医学V视界——国内领先的医生直播社交平台。', 'http://cdn.yxvzb.com/newWechat/image/logo98.png', location.href.split('#')[0], location.href.split('#')[0] + '#/');
    }
  });
  router.afterEach(function (to, from) {
    var shence_id = Api.getStorage('wxUserInfo') ? Api.getStorage('wxUserInfo').shenceId || '' : ''; // 神策公共属性

    Vue.prototype.$sa.registerPage({
      platform: 'wx',
      operation_tm: new Date().getTime(),
      // to.query.shequn 为了兼容以前数据
      frompage_name: to.query.isTemp || (to.query.shequn ? 6 : to.query.shareFlag ? '分享' : to.query.visiterId ? '课代表邀请' : from.meta.pageName || ''),
      frompage_url: from.fullPath || '',
      currentpage_name: to.meta.pageName,
      currentpage_url: to.fullPath,
      shence_id: shence_id,
      env: config.env // 为了兼容 以前埋点 该字段已合并到frompage_name
      // fromcode:to.query.isTemp || (to.query.shequn ? 6 : ''), // 1首关  2 菜单 3模板 4 客服消息 5 图文消息 6 社群 7 分享
      // is_share:to.query.shareFlag ? '是' : '否'

    }); // 浏览轨迹

    Vue.prototype.$sa.re_pageview();
    setTimeout(function () {
      store.dispatch('change', false);
    }, 500);
  });
});